<div class="multiadd">

  <form [formGroup]="uiMultirowBasicForm" class="multiadd-grid">
    <nz-form-item>
      <nz-form-control [nzSpan]="24">
        <nz-select nzShowSearch id="typeCd" formControlName="typeCd" style="width: 100%" [nzDisabled]="isReadOnly">
          <nz-option *ngFor="let item of (lookup$[lookupTypeCd] | async) as lookupTypeCdLookup; trackBy:item?.lookupKey"
            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
        </nz-select>

        <nz-form-explain
          *ngIf="(uiMultirowBasicForm.get('typeCd').dirty || uiMultirowBasicForm.get('typeCd').touched) && uiMultirowBasicForm.get('typeCd').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(uiMultirowBasicForm.get('typeCd'), UIMULTIROWBASICFORMNAME)">
            {{error.errorMessage || error}}</p>
        </nz-form-explain>
      </nz-form-control>
    </nz-form-item>

    <nz-form-control [nzSpan]="24" *ngIf="type == 'email'">
      <input nz-input placeholder="{{'Email' | translate}}" formControlName="emailId" [disabled]="isReadOnly"/>
      <nz-form-explain
        *ngIf="(uiMultirowBasicForm.get('emailId').dirty || uiMultirowBasicForm.get('emailId').touched) && uiMultirowBasicForm.get('emailId').errors">
        <p style="color:red"
          *ngFor="let error of validationUtilService.getUIErrorList(uiMultirowBasicForm.get('emailId'), UIMULTIROWBASICFORMNAME)">
          {{error.errorMessage || error}}</p>
      </nz-form-explain>
    </nz-form-control>

    <nz-form-control [nzSpan]="24" *ngIf="type == 'phone'">

      <input nz-input placeholder="{{'Number' | translate}}" formControlName="phone"
        onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="10" [disabled]="isReadOnly" />
      <!-- <nz-form-explain
              *ngIf="(uiMultirowBasicForm.get('phone').dirty || uiMultirowBasicForm.get('phone').touched) && uiMultirowBasicForm.get('phone').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(uiMultirowBasicForm.get('phone'), UIMULTIROWBASICFORMNAME)">
                {{error || '' |translate}}</p>
            </nz-form-explain> -->
      <nz-form-explain *ngIf="mobLengthVal == false">
        <p style="color:red">
          Mobile number is not valid
        </p>
      </nz-form-explain>
    </nz-form-control>
    <!-- <input type="text" nz-input placeholder="{{placeholderVal || '' |translate}}" /> -->

    <!-- Button Add row (FIRST ROW WILL HAVE THIS) -->
    <button nz-button nzType="dashed" (click)="addRow()" [disabled]="isReadOnly">
      <i class="icon-s-15" nz-icon nzType="plus" nzTheme="outline"></i>
    </button>

  </form>
  <!-- Heading -->
  <div class="multiadd-grid multiadd-grid-4" *ngIf="(type === 'email' && emailList && emailList.length > 0)">
    <small class="f-s-tiny" translate>Preferred</small>
  </div>
  <!-- DEMO REPEAT OF ROWS -- Can Ignore -->
  <div class="multiadd-grid multiadd-grid-4" *ngIf="type === 'email'">

    <ng-container *ngFor="let row of emailList; let i = index;">
      <div class="flex flex-both-center">
        <div>
          <label nz-checkbox [(ngModel)]="row.prefferedFl" (ngModelChange)="deselectOtherEmailsPrefferedFl(i)"></label>
        </div>
      </div>
      <div class="inputs-are-disabled">
        <nz-select nzShowSearch id="typeCd" [(ngModel)]="row.typeCd" style="width: 100%" [disabled]="isReadOnly">
          <nz-option *ngFor="let item of (lookup$[lookupTypeCd] | async) as lookupTypeCdLookup; trackBy:item?.lookupKey"
            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
        </nz-select>
      </div>
      <!-- Input -->
      <div class="inputs-are-disabled">
        <input type="text" nz-input [(ngModel)]="row.emailId" [disabled]="isReadOnly" />
      </div>
      <button nz-button nzType="dashed" nz-popconfirm nzPopconfirmTitle="Remove this row?" nzOkText="Remove" nzCancelText="Cancel"
        (nzOnConfirm)="removeRow(i)" [disabled]="isReadOnly">
        <i nz-icon nzType="delete" nzTheme="outline"></i>
      </button>
    </ng-container>
  </div>

  <div class="multiadd-grid multiadd-grid-4" *ngIf="type === 'phone'">
    <ng-container *ngFor="let row of phoneList; let i = index;">
      <div class="flex flex-both-center">
        <div>
          <!-- <nz-radio-group [(ngModel)]="row.prefferedFl">
                  <label nz-radio [nzValue]="i" class="m-r-0"></label>
                </nz-radio-group> -->
          <label nz-checkbox [(ngModel)]="row.prefferedFl" (ngModelChange)="deselectOtherPhonesPrefferedFl(i)"></label>
        </div>
      </div>
      <div class="inputs-are-disabled">
        <nz-select nzShowSearch id="typeCd" [(ngModel)]="row.typeCd" style="width: 100%" [nzDisabled]="isReadOnly">
          <nz-option *ngFor="let item of (lookup$[lookupTypeCd] | async) as lookupTypeCdLookup; trackBy:item?.lookupKey"
            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
        </nz-select>
      </div>
      <!-- Input -->
      <div class="inputs-are-disabled">
        <input type="text" nz-input [(ngModel)]="row.contactNum"   [disabled]="isReadOnly"
        />
      </div>
      <button nz-button nzType="dashed" nz-popconfirm nzPopconfirmTitle="Remove this row?" nzOkText="Remove" nzCancelText="Cancel"
        (nzOnConfirm)="removeRow(i)" [disabled]="isReadOnly">
        <i nz-icon nzType="delete" nzTheme="outline"></i>
      </button>
    </ng-container>
  </div>
</div>